<template>
  <div>
    <header-page
      :namePage="$t('pagesTitles.mc')"
      :isSearchInput="true"
      :links="$store.state.headerLinks.mimkMcLinks"
      :height="222"
      @searchByAmoId="searchByAmoId"
      @openSalaryModal="openSalaryModal"
    />
    <div class="content mk">
      <ReportModals @changeLoader="changeLoader" ref="reportModal" />
      <MimkModal
        ref="mimkModal"
        :statusMasterClass="statusMasterClass"
        :studnentReason="studnentReason"
        @clearParentsData="clearParentsData"
        @saveMcData="saveMcData"
      />
      <SalaryModal ref="salaryModal" />
      <v-select
        v-if="userRole === 'admin'"
        class="select-mimk"
        :options="$store.state.user.mimkList"
        :placeholder="$t('mc.placeholders.selectMimkFromList')"
        :loading="!$store.state.user.mimkListLoaded"
        :clearable="false"
        @input="setMimk"
      />
      <SearchPeriod @searchByDate="searchByDate" />
      <loader v-if="isLoad" />
      <template v-else>
        <TableCommon
          ref="mcTableCurrent"
          :choisenMimkIdByAdmin="userId"
          :startedPeriod="startSearchDate"
          :finishedPeriod="finishSearchDate"
          :emptyTableTitleName="emptyTitle"
          :sizeColumn="sizeColumn"
          :propsTableData="currentData"
          :isCurrent="true"
          @callReportTypeModal="callReportTypeModal"
          @choiseTotal="choiseTotal"
          :zoomActive="true"
        />
        <TableCommon
          ref="mcTableFuture"
          :choisenMimkIdByAdmin="userId"
          :startedPeriod="startSearchDate"
          :finishedPeriod="finishSearchDate"
          :emptyTableTitleName="emptyTitle"
          :sizeColumn="sizeColumn"
          :propsTableData="futureData"
          @callReportTypeModal="callReportTypeModal"
          :isFuture="true"
          @choiseTotal="choiseTotal"
          :zoomActive="true"
        />
        <div
          class="empty-mk-title"
          v-if="!this.futureData.length && !this.currentData.length"
        >
          {{ $t("mc.mimk.notFoundCurrentAndFeatures") }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import SearchPeriod from "@/components/UI/DatePickerPeriod";
import TableCommon from "@/components/Mimk/TableCommon";
import ReportModals from "@/components/Mimk/Modals/Report";
// import ReportMcModal from "@/components/Mimk/Modals/ReportMcModal";
// import ReportPaymentModal from "@/components/Mimk/Modals/ReportPaymentModal";
import MimkModal from "@/components/Mimk/Modals/McModal";
import SalaryModal from "@/components/Mimk/Modals/SalaryModal";
import apiBooking from "@/api/master-classes/booking";
import apiTags from "@/api/tags";
export default {
  data() {
    return {
      selectedMimk: "",
      sizeColumn: "1fr 16px 1fr 2fr 2fr 1fr",
      startSearchDate: "",
      finishSearchDate: "",
      studnentReason: false,
      statusMasterClass: "",
      checkedMkId: "",
      isLoad: false,
      currentData: [],
      futureData: [],
      // reportMcModalOpenId: "",
    };
  },
  components: {
    TableCommon,
    SearchPeriod,
    MimkModal,
    // ReportMcModal,
    // ReportPaymentModal,
    ReportModals,
    SalaryModal,
  },
  async created() {
    try {
      this.$metrika.reachGoal("TCM_click_current_future_tc_tab");
    } catch (err) {
      console.log(err);
    }
    // await apiBooking.addSuccessMkinfo('62459074acc550359c639e89', 'В работе')
    this.userId = this.$store.state.user.user.id;
    //Функция получения списка всех букингов за определенную дату и айди мимка
    await this.getAllBookings();
  },
  computed: {
    salaryModals() {
      return this.$store.state.globalModals.salaryModal;
    },
    userRole() {
      return this.$store.state.user.user.role;
    },
    //Передаем пропсом для отображения текста если нет данных для какой-то из таблиц либо нет данных для обоих
    emptyTitle() {
      let title;
      if (!this.futureData.length && !this.currentData.length) title = "";
      else {
        if (!this.futureData.length) title = this.$t("mc.mimk.titleNext");
        if (!this.currentData.length) title = this.$t("mc.mimk.titleCurrent");
      }
      return title;
    },
  },
  methods: {
    openSalaryModal() {
      this.$refs.salaryModal.openModal();
    },
    async distributeAfterClassCanceled() {
      const segment = await apiBooking.getSegmentInfo(
        this.$store.state.user.segment.title
      );
      const localTime = this.$dayjs(segment.segment_local_time).format("HH:mm");
      let firstCompareTime = `${this.$dayjs(segment.segment_local_time).format(
        "HH"
      )}:10`;
      let secondCompareTime = `${this.$dayjs(segment.segment_local_time).format(
        "HH"
      )}:45`;
      let firstTimeDifference = this.$dayjs(localTime, "HH:mm").diff(
        this.$dayjs(firstCompareTime, "HH:mm"),
        "minute"
      );
      let secondTimeDifference = this.$dayjs(localTime, "HH:mm").diff(
        this.$dayjs(secondCompareTime, "HH:mm"),
        "minute"
      );
      if (firstTimeDifference <= 0 || secondTimeDifference >= 0) {
        await apiBooking.manualDistribute();
      }
    },
    async changeLoader(boolean) {
      if (boolean) this.isLoad = boolean;
      else {
        await this.getAllBookings("loadingByPickerDate");
        this.$nextTick(() => (this.isLoad = boolean));
      }
    },
    callReportTypeModal(emitObj) {
      this.$refs.reportModal.callModal(
        emitObj.type,
        emitObj.reportMcModalFields,
        emitObj.element
      );
    },
    async searchByDate({ start, finish }) {
      this.isLoad = true;
      this.startSearchDate = start;
      this.finishSearchDate = finish;
      //Вызываем метод и передаем аргументом, параметр указывающий, что грузим МК с выбранными датами которые берем из  this.startSearchDate и this.finishSearchDate
      await this.getAllBookings("loadingByPickerDate", !!this.selectedMimk);
      this.isLoad = false;
    },
    async searchByAmoId(searchedString) {
      this.isLoad = true;
      const role = this.$store.state.user.user.role;
      let mimkId =
        role === "admin"
          ? this.choisenMimkIdByAdmin
          : this.$store.state.user.user.id;
      this.searchedMasterClasses = await apiBooking.getMkByLink(
        searchedString,
        mimkId
      );
      if (!this.searchedMasterClasses) {
        this.isLoad = false;
      } else {
        this.futureData = [...this.searchedMasterClasses.future];
        this.currentData = [...this.searchedMasterClasses.current];
        this.isLoad = false;
      }
    },
    //Метод который вызываем при взаимодействии МИМКа с МК (нажатия кнопки с присваиванием статуса МК в таблице)
    async choiseTotal({ status, id, studnentReason }) {
      //Если выбираем статус "В работе" Отправляем запрос с айди МК на изменения статуса
      if (status === this.$store.state.statuses.mcStatuses.inWork) {
        this.isLoad = true;
        await apiBooking.addSuccessMkinfo(id, status);
        await this.getAllBookings("loadingByPickerDate", !!this.selectedMimk);
        this.isLoad = false;
        return;
      }
      //Параметр для передачи в пропс для отображения текста в модалке 'Мастер-класс успешно совершен' либо 'Ученик не пришёл'
      if (studnentReason) this.studnentReason = true;
      else this.studnentReason = false;
      //id который понадобиться нам в saveMcData для передачи параметра в addSuccessMkinfo
      this.checkedMkId = id;
      //Пропс для передачи в компонент с модалкой для определения : тайтла, дизайбл-кнопки и отображения селекта с выбором причин отмены
      this.statusMasterClass = status;
      this.$refs.mimkModal.openModal();
      this.isLoad = false;
    },
    async saveMcData(modalData) {
      //Принимаем параметр modalData это объект в котором содержаться опциональные поля comment и reason
      //Объединяем МК из 2 таблиц для поиска таска по одному массиву
      const allMc = [...this.currentData, ...this.futureData];
      const foundTask = allMc.findIndex((el) => el.id === this.checkedMkId);
      //Найденную задачу присваиваем в переменную task , для дальнейшией отправки на изменение МК нам нужно забрать из это переменной айдишник задачи
      let task = allMc[foundTask];
      this.isLoad = true;
      const status = this.statusMasterClass;
      await apiBooking.addSuccessMkinfo(task.id, status, modalData);
      if (status === this.$store.state.statuses.mcStatuses.cancel)
        await this.distributeAfterClassCanceled();
      await this.getAllBookings("loadingByPickerDate", !!this.selectedMimk);
      this.isLoad = false;
    },
    async getAllBookings(pickerDate, getMcAfterCahngeMimk) {
      this.isLoad = true;
      //Получаем сегодняшний день, при рендеринге страницы у нас сначала отображаются МК за текущий день
      let firstDate = this.$dayjs(new Date()).format("YYYY-MM-DD") + " 00:00";
      let secondDate = this.$dayjs(new Date()).format("YYYY-MM-DD") + " 00:00";
      //Если в метод getAllBookings Передаем параметр со строкой, значит даты уже были выбраны и мы будем передавать эти даты в запрос
      if (pickerDate) {
        firstDate =
          this.$dayjs(this.startSearchDate, "DD.MM.YYYY").format("YYYY-MM-DD") +
          " 00:00";
        secondDate =
          this.$dayjs(this.finishSearchDate, "DD.MM.YYYY").format(
            "YYYY-MM-DD"
          ) + " 00:00";
      }
      // Сейчас мы находимся на странице где присутствует Таблица с будущими МК  и передвавая loadAllFutureMc, мы передаем в getMimkBookings
      // параметр future = true , который грузит все мк для таблицы будущих МК независимо от даты
      const loadAllFutureMc = true;
      this.isLoad = true;
      //Дергаем запрос который грузит нам все МК
      const mkList = await apiBooking.getMimkBookings(
        firstDate,
        secondDate,
        this.userId,
        loadAllFutureMc,
        getMcAfterCahngeMimk
      );
      // помещаем данные в поля из data, для передачи пропсами в компонент TableCommon
      // const obj = [
      //   {"id":"61f8f8b5115b474d3d3d0985","student":{"name":"Вова Иванов","info":"это комментарийы"},"date":{"start":"22.02.2022","hour":"16:00"},"extraInformation":{"parentName":"Клара","parentNumber":"79999999999","segment":null,"backofficeLink":"https://backoffice.kodland.org/student_440565","amoLink":"https://kodland.amocrm.ru/leads/detail/32675522"},"status":"В работе"},
      //   {"id":"61f8f8b5115b474d3d3d098","student":{"name":"Вова Иванов","info":"это комментарийы"},"date":{"start":"22.02.2022","hour":"17:00"},"extraInformation":{"parentName":"Клара","parentNumber":"79999999999","segment":null,"backofficeLink":"https://backoffice.kodland.org/student_440565","amoLink":"https://kodland.amocrm.ru/leads/detail/32675522"},"status":"В работе"}
      // ]

      this.currentData = [...mkList.current];
      this.futureData = [...mkList.future];

      this.isLoad = false;
    },
    //Метод для изменения айди мимка (Данный фунционал доступен только админу)
    async setMimk(mimk) {
      this.userId = mimk.id;
      //Проверяем есть ли выбранная дата, если есть, то грузим по выбранной дате, если нет то по сегодняшнему дню
      let loadByGotPickerDate = this.startSearchDate
        ? "loadingByPickerDate"
        : false;
      await this.getAllBookings(loadByGotPickerDate, !!this.selectedMimk);
    },
    clearParentsData() {
      this.statusMasterClass = null;
      this.checkedMkId = null;
    },
  },
  watch: {
    salaryModals(value) {
      if (value) this.$refs.salaryModal.openModal();
    },
    futureData() {
      if (this.futureData.length) {
        const bookingIds = this.futureData.map(booking => booking.id)
        const mimkIds = this.futureData.map(booking => booking.mimk)

        if (bookingIds.length) apiTags.getBookingsTags(bookingIds, true)
        if (mimkIds.length) apiTags.getMimksTags(mimkIds, this.$store.state.user.segment.id, true)
      }
    },
    currentData() {
      if (this.currentData.length) {
        const bookingIds = this.currentData.map(booking => booking.id)
        const mimkIds = this.currentData.map(booking => booking.mimk)

        if (bookingIds.length) apiTags.getBookingsTags(bookingIds, true)
        if (mimkIds.length) apiTags.getMimksTags(mimkIds, this.$store.state.user.segment.id, true)
      }
    },
  },
};
</script>
